export default __webpack_public_path__ + "static/media/eastlink-blue.2791b580.png";